var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-label",class:[
    {'vm-label-bold': _vm.bold},
    {'vm-label-outside': _vm.outside},
    {'vm-label-topmargin': _vm.topMargin},
    {'vm-label-error': _vm.error} ]},[_c('label',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }